import React, { Component } from 'react';
import styled from 'styled-components';
import Particles from 'react-particles-js';

const ParticleEle = styled(Particles)`
  .tsparticles-canvas-el {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`;

class ParticlesBackground extends Component {
  render() {
    return (
      <ParticleEle
        params={{
          background: {},
          backgroundMask: {
            cover: {
              color: {
                value: '#fff',
              },
              opacity: 0,
            },
            enable: false,
          },
          detectRetina: true,
          fpsLimit: 30,
          infection: {
            cure: false,
            delay: 0,
            enable: false,
            infections: 0,
            stages: [],
          },
          interactivity: {
            detectsOn: 'canvas',
            events: {
              onClick: {
                enable: true,
                mode: 'push',
              },
              onDiv: {
                elementId: '',
                enable: false,
                mode: [],
              },
              onHover: {
                enable: true,
                mode: 'repulse',
                parallax: {
                  enable: false,
                  force: 60,
                  smooth: 10,
                },
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              connect: {
                distance: 80,
                links: {
                  opacity: 0.1,
                },
                radius: 60,
              },
              grab: {
                distance: 400,
                links: {
                  opacity: 1,
                },
              },
              push: {
                quantity: 4,
              },
              remove: {
                quantity: 2,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
                speed: 1,
              },
              slow: {
                factor: 3,
                radius: 200,
              },
            },
          },
          particles: {
            collisions: {
              enable: false,
              mode: 'bounce',
            },
            color: {
              value: '#ffffff',
              animation: {
                enable: true,
                speed: 1,
                sync: true,
              },
            },
            links: {
              blink: false,
              color: {
                value: '#ffffff',
              },
              consent: false,
              distance: 100,
              enable: true,
              opacity: 0.1,
              shadow: {
                blur: 10,
                color: {
                  value: 'lime',
                },
                enable: true,
              },
              triangles: { enable: false },
              width: 1,
              warp: true,
            },
            move: {
              attract: {
                enable: true,
                rotate: {
                  x: 300,
                  y: 1200,
                },
              },
              direction: 'none',
              enable: true,
              noise: {
                delay: {
                  random: {
                    enable: false,
                    minimumValue: 0,
                  },
                  value: 0,
                },
                enable: false,
                factor: {
                  horizontal: {
                    value: 10,
                    offset: 0,
                  },
                  vertical: {
                    value: 10,
                    offset: 40000,
                  },
                },
              },
              outMode: 'out',
              random: true,
              speed: 1,
              straight: false,
              trail: {
                enable: false,
                length: 1000,
                fillColor: {
                  value: '#000000',
                },
              },
              vibrate: false,
              warp: false,
            },
            number: {
              density: {
                enable: true,
                area: 2000,
                factor: 6000,
              },
              limit: 0,
              value: 100,
            },
            opacity: {
              animation: {
                enable: true,
                minimumValue: 0.1,
                speed: 1,
                sync: false,
              },
              random: {
                enable: false,
                minimumValue: 1,
              },
              value: 0.35,
            },
            rotate: {
              animation: {
                enable: false,
                speed: 1,
                sync: false,
              },
              direction: 'clockwise',
              random: false,
              value: 0,
            },
            shadow: {
              blur: 0,
              color: { value: '#64ffda' },
              enable: false,
              offset: { x: 0, y: 0 },
            },
            shape: {
              options: {
                char: {
                  fill: true,
                  close: true,
                  font: 'Calibre',
                  style: '',
                  value: [
                    'React',
                    'React Native',
                    'Redux',
                    'JavaScript',
                    'TypeScript',
                    'Angular',
                    'Vue',
                    'Node',
                    'Python',
                    'Django',
                    'Flask',
                    'Gatsby',
                    'Contentful CMS',
                    'NextJS',
                    'Strapi CMS',
                    'Headless CMS',
                    'GraphQL',
                    'AWS',
                  ],
                  weight: '100',
                },
                polygon: { fill: true, close: true, sides: 500 },
                star: { fill: true, close: true, sides: 500 },
              },
              type: 'char',
            },
            size: {
              animation: {
                destroy: 'none',
                enable: false,
                minimumValue: 10,
                speed: 10,
                startValue: 'max',
                sync: false,
              },
              random: { enable: false, minimumValue: 1 },
              value: 8,
            },
            stroke: { color: { value: '#64ffda' }, width: 1, opacity: 1 },
            twinkle: {
              lines: { enable: true, frequency: 0.005, opacity: 0.5 },
              particles: { enable: false, frequency: 0.005, opacity: 0.5 },
            },
          },
          pauseOnBlur: true,
        }}
      />
    );
  }
}

export default ParticlesBackground;
